@if (isLoaded()) {
  <div
    class="landing"
    *transloco="let t">
    <div class="register-user-new">
      <!-- If user follows invitation link with it disabled in admin panel -->
      <div class="register-user-new_form">
        <app-company-logo [width]="200" />
        <div class="register-user-new_inner">
          <h2 class="register-user-new_title">
            {{ t('registration-new.sign-up-disabled') }}
          </h2>
          <div class="register-user-new_footnote">
            {{ t('auth.login.have-account') }}
            <a [href]="logInUrl()">
              {{ t('registration-new.log-in') }}
            </a>
          </div>
        </div>
        <div class="layout_footer">
          <app-legal-terms-footer />
        </div>
      </div>
      <div appBackgroundBranded></div>
    </div>
  </div>
} @else {
  <app-icon
    class="layout_spinner"
    name="spinner" />
}
